import React from 'react';
import moment from 'moment';
import { Skeleton } from 'antd';
// import { useGlobalState } from '../../../store/state'
// import './ProfileAboutComponent.styles.scss'
import UpdateBankDetailsForm from './UpdateBankDetailsForm';

const ProfileBankComponent = ({ loading, profile }) => {
  // const [user] = useGlobalState('user')
  return (
    <div className="col-md-12 px-2 mt-3">
      <div className="common_card p-3 h-100 profile_about_card">
        <h5>Wallet Details</h5>
        <UpdateBankDetailsForm/>
      </div>
    </div>
  );
};

export default ProfileBankComponent;
